import { AuthFormType } from 'src/components/AuthNew/types';
import { css } from 'styled-components';

export const authLayoutCSS = {
  [AuthFormType.Login]: {
    loginFormCSS: css`
      background: var(--background);
    `,
  },
  [AuthFormType.Registration]: {
    containerCSS: css`
      width: 100%;
    `,
    wrapperCSS: css`
      width: 100%;
    `,
  },
  [AuthFormType.LoginWithPassword]: {
    containerCSS: css`
      width: 290px;
    `,
    wrapperCSS: css`
      width: 100%;
    `,
  },
  [AuthFormType.LoginWithSMSCode]: {
    containerCSS: css`
      width: 290px;
    `,
    wrapperCSS: css`
      width: 100%;
    `,
  },
};
